 
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { TextField, Stack, Typography, Box } from '@mui/material';

const AgeFilter = function AgeFilter({ defaultMin = 18, defaultMax = 99 }) {
  const intl = useIntl();
  const { setValue } = useFormContext();
  const [lowerAge, setLowerAge] = useState(18);
  const [upperAge, setUpperAge] = useState(99);

  useEffect(() => {
    setLowerAge(defaultMin);
  }, [defaultMin]);
  useEffect(() => {
    setUpperAge(defaultMax);
  }, [defaultMax]);

  useEffect(() => {
    setValue('lowerAge', parseInt(lowerAge, 10));
  }, [lowerAge]);
  useEffect(() => {
    setValue('upperAge', parseInt(upperAge, 10));
  }, [upperAge]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "8px"
      }}>
      <Typography sx={{ fontSize: '14px' }}>{intl.messages.AGE}:</Typography>
      <Stack direction="row" spacing={2}>
        <TextField
          label={intl.messages.MIN}
          value={lowerAge}
          onChange={(e) => setLowerAge(e.target.value)}
          type="number"
          InputProps={{ inputProps: { min: 18, max: 99 } }}
        />
        <TextField
          label={intl.messages.MAX}
          type="number"
          value={upperAge}
          onChange={(e) => setUpperAge(e.target.value)}
          InputProps={{ inputProps: { min: 18, max: 99 } }}
        />
      </Stack>
    </Box>
  );
};

AgeFilter.propTypes = {
  defaultMin: PropTypes.number,
  defaultMax: PropTypes.number,
};

export default AgeFilter;
